export const NODE_ENV = process.env.NODE_ENV;
export const REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const REACT_APP_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const REACT_APP_HOST_ENV = process.env.REACT_APP_HOST_ENV;
export const REACT_APP_HOSTNAME = process.env.REACT_APP_HOSTNAME;
export const REACT_APP_PORT = process.env.REACT_APP_PORT;
export const REACT_APP_SCHEME = process.env.REACT_APP_SCHEME;
export const REACT_APP_ALLOW_UNSECURED_HTTP = process.env.REACT_APP_ALLOW_UNSECURED_HTTP;
export const REACT_APP_BILLING_PORTAL_HOST = process.env.REACT_APP_BILLING_PORTAL_HOST;
export const REACT_APP_CHARGIFY_PUBLIC_KEY = process.env.REACT_APP_CHARGIFY_PUBLIC_KEY;
export const REACT_APP_CHARGIFY_SERVER_HOST = process.env.REACT_APP_CHARGIFY_SERVER_HOST;
// COMPONENT handles
export const REACT_APP_EMR_COMPONENT_HANDLE = process.env.REACT_APP_EMR_COMPONENT_HANDLE;
export const REACT_APP_AUTOMATED_ANSWERING_SERVICE_COMPONENT_HANDLE = process.env.REACT_APP_AUTOMATED_ANSWERING_SERVICE_COMPONENT_HANDLE;
export const REACT_APP_MINUTES_COMPONENT_HANDLE = process.env.REACT_APP_MINUTES_COMPONENT_HANDLE;
export const REACT_APP_ON_CALL_PROVIDERS_COMPONENT_HANDLE = process.env.REACT_APP_ON_CALL_PROVIDERS_COMPONENT_HANDLE;
export const REACT_APP_SUPPORT_COMPONENT_HANDLE = process.env.REACT_APP_SUPPORT_COMPONENT_HANDLE;
export const REACT_APP_VOICESENSE_COMPONENT_HANDLE = process.env.REACT_APP_VOICESENSE_COMPONENT_HANDLE;

// Stamped into the image at build time by CI (`--build-arg APP_VERSION`), so it
// is a real value in the bundle rather than an entrypoint substitution. The
// sentinel covers any unstamped build - a local `npm start`, or an image built
// without the arg - and is deliberately not a version.
export const APP_VERSION = process.env.REACT_APP_VERSION || 'development';

// Computed constants
export const CORE_API_BASE_URL = `${REACT_APP_API_ENDPOINT}/api/public`;
